import { render, staticRenderFns } from "./CocPreview.vue?vue&type=template&id=511b4c64&scoped=true"
import script from "./CocPreview.vue?vue&type=script&lang=js"
export * from "./CocPreview.vue?vue&type=script&lang=js"
import style0 from "./CocPreview.vue?vue&type=style&index=0&id=511b4c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b4c64",
  null
  
)

export default component.exports